import Vue from 'vue'
import VueRouter from 'vue-router'
import Checkout from '@/views/Checkout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Checkout',
    component: Checkout
  },
  {
    path: '/remember-me-settings',
    name: 'Remember me settings',
    // route level code-splitting
    // this generates a separate chunk (remember-me-settings.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "remember-me-settings" */ '@/views/RememberMeSettings.vue')
  },
  {
    path: '/*',
    name: 'Not found',
    component: () => import(/* webpackChunkName: "not-found" */ '@/views/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_ROUTER_BASE, // dynamically defined in vue.config.js
  routes
})

export default router
